import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LocalStorage } from 'src/utils/local-storage';
import { HomeModule } from './home/home.module';
import { PagesModule } from './pages/pages.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { JsonTranslationLoader } from 'src/translation-loader';
import { ReactiveFormsModule } from '@angular/forms';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { SharedModule } from './shared/shared.module';
import { ModalsModule } from './modals/modals.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HubComponentsModule } from './hub-components/hub-components.module';
import { NavigationModule } from './navigation/navigation.module';
import { HubService } from 'src/services/hub.service';
import { HttpClientModule } from '@angular/common/http';

export function FSLoaderFactory(): JsonTranslationLoader {
  return new JsonTranslationLoader();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HomeModule,
    HubComponentsModule,
    NavigationModule,
    PagesModule,
    SharedModule,
    ModalModule.forRoot(),
    ModalsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: FSLoaderFactory,
      }
    }),
    BrowserAnimationsModule,
  ],
  providers: [
    LocalStorage,
    HubService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
